import {IGame, PagingType} from "@backend/types"
import {gameActions} from "./service"

type GameState = {
    games?: PagingType<IGame>
}

export function gameReducer(state: GameState = {}, action): GameState {

    switch (action.type) {
        case gameActions.actionTypes.LIST: {
            const games: PagingType<IGame> = action.payload
            return {games}
        }
        case gameActions.actionTypes.CREATE: {
            const game: IGame = action.payload

            const {games: stateGames} = state

            if (stateGames) {
                stateGames.docs.unshift(game)
                stateGames.totalDocs += 1
                return {games: {...stateGames}}
            } else {
                return {}
            }
        }
        case gameActions.actionTypes.CLEAR: {
            return {}
        }
        case gameActions.actionTypes.DELETE: {
            const gameId = action.payload
            const {games: stateGames} = state

            if (stateGames) {
                stateGames.docs = stateGames.docs.filter(game => game._id !== gameId)
                stateGames.totalDocs -= 1
                return {games: {...stateGames}}
            } else {
                return {}
            }
        }

        default:
            return state
    }
}
